"use strict";

var onYouTubePlayerAPIReady;

var youTubePlayerReady = false;
var pageLoaded = false;


(function ($) {

    var isIphone = false;
    var isIpad = false;
    var isAndroid = false;


    if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
        isIphone = true;

        $('html').addClass('iphone');
    }

    if (navigator.userAgent.match(/iPad/i)) {
        isIpad = true;

        $('html').addClass('ipad');
    }

    if (navigator.userAgent.match(/android/i)) {
        isAndroid = true;
    }

    //************************************
    // RESIZE VIDEO
    //************************************

    function vidRescale() {

        $('.background-video').each(function () {

            var _width = $(this).width() + 1;
            var _height = $(this).height() + 1;

            var _ratio_x = $(this).data('ratio-x') || 16;
            var _ratio_y = $(this).data('ratio-y') || 9;

            var _video = $(this).find('video, iframe');

            if (_width / _height > _ratio_x / _ratio_y) {

                _video.css({
                    "width": _width,
                    "height": _width / _ratio_y * _ratio_x
                });


            } else {

                _video.css({
                    "width": _height / _ratio_y * _ratio_x,
                    "height": _height
                });
            }

        });

    }


    function initPreloader() {
        TweenMax.staggerTo('#preloader .stripes polygon', 1, {opacity: 0, repeat: -1, yoyo: true}, 0.1);
    }

    initPreloader();

    initJWAlogo();




    //************************************
    // SET BACKGROUNDS FOR IPHONE
    //************************************

    function setImageBackground() {

        $('[data-background-image]').each(function(){

            $(this).css('background-image', 'url(' + $(this).data('background-image') + ')');
        })
    }

    if (isIphone) {
        setImageBackground();
    }


    //************************************
    // AUTO PLAY VIDEO ON HOME
    //************************************


    if (!isIphone){

        if ($('body').hasClass('home-page')) {

            $('video').each(function(){
                $(this).get(0).play();
            })
        }
    }


    //************************************
    // AUTO PLAY FOR IPAD
    //************************************

    function autoPlayVideoForIpad() {

        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var triggerPosition = scrollTop + windowHeight;

        $('.travel-block').each(function () {

            var _ = $(this);

            var offset = _.offset();

            var currentVideo;

            var triggerAreaStart = offset.top + _.height() / 2;
            var triggerAreaEnd = offset.top + _.height() + 40;

            if (triggerPosition > triggerAreaStart && triggerPosition < triggerAreaEnd) {

                currentVideo = $('.travels-blocks-list .travel-block').eq(_.index()).find('video');

                currentVideo.addClass('playing').get(0).play();

            }

            else {

                currentVideo = _.find('video');

                if (currentVideo.hasClass('playing')) {
                    currentVideo.removeClass('playing').get(0).pause();
                }
            }

        })
    }


    function hidePreloader() {

        var tl = new TimelineLite();

        tl.to('#preloader .plane', 0.3, {physics2D: {velocity: 900, angle: -60}});
        tl.to('#preloader', 0.3, {autoAlpha: 0}, '-=.2');

        TweenMax.killTweensOf($("#preloader .stripes polygon"));

        animateJWAlogo();


        if ($('body').hasClass('home-page')) {
            pageLoaded = true;

            if (!isAndroid && !isIpad && !isIphone){

                setTimeout(function(){
                    ytPlayerPlay();
                }, 300)
            }
        }
    }

    function initJWAlogo() {
        TweenLite.set('#header-jwa-logo .plane-stripes', {rotation: 30, x: 10, transformOrigin: "50% 50%"})
        TweenLite.set('#header-jwa-logo .plane-stripes .stripes', {scaleY: 0, transformOrigin: "50% 100%"})
        TweenLite.set('#header-jwa-logo .plane-stripes .plane', {y: "500%", opacity: 0})
        TweenLite.set('#header-jwa-logo .left-figure', {x: '40%'})
        TweenLite.set('#header-jwa-logo .right-figure', {x: '-40%'})
        TweenLite.set('#header-jwa-logo .text', {opacity: 0})
    }


    function animateJWAlogo() {

        var tl = new TimelineLite();

        tl.to('#header-jwa-logo .left-figure, .right-figure', .5, {x: '0%'});
        tl.to('#header-jwa-logo .plane-stripes .plane', 1, {y: "0%", opacity: 1})
        tl.to('#header-jwa-logo .plane-stripes .stripes', 1, {scaleY: 1}, '-=1')
        tl.to('#header-jwa-logo .text', 0.4, {opacity: 1}, '-=0.5')

    }


    $("button.next-section").click(function () {

        $('html, body').animate({
            scrollTop: $("#section-title").offset().top
        }, 800);
    });


    $(window).on('resize load', function () {
        vidRescale();
    });


    function setClipContainerHeight() {

        var ww = $(window).width();

        $('.home-page .content-col .clip-block').each(function () {

            var _ = $(this);
            var _parent = _.closest('.clip-container');
            var _imgCol = _parent.find('.image-col');

            if (ww > 900) {
                _parent.height(_.outerHeight());
            }
            else {
                _imgCol.height(_.outerHeight());
            }

        });
    }

    function setClipParentHeight() {
        $('.clip-need-height').each(function () {

            var $this = $(this);
            var $thisChild = $this.find('.clip-block');

            $this.height($thisChild.outerHeight());

        });
    }


    function ClipBlocksAnimation(settings) {

        var _ = this;

        var clipBlocks;

        _.create = function () {

            setClipInitSize();

            callNotViewed();

            $(document).on('scroll', function (event) {

                callNotViewed();

            });

        };

        function callNotViewed() {
            clipBlocks = $(settings.selector + ":not('viewed')");

            if (clipBlocks.length > 0) {
                isOnScreenClipBlock(clipBlocks);
            }
        }


        function isOnScreenClipBlock(blocks) {

            blocks.each(function (index) {

                var _ = $(this);

                if (_.isOnScreen(0.3, 0.3)) {

                    animateBlockClip(_, index);
                }

            });
        }


        function animateBlockClip(clipBlock, index) {

            var thisClipBlock = clipBlock;

            var thisWidth = thisClipBlock.outerWidth();
            var thisHeight = thisClipBlock.outerHeight();

            TweenLite.to(thisClipBlock, 1, {
                clip: "rect(0px " + thisWidth + "px " + thisHeight + "px 0)",

                onComplete: function () {
                    thisClipBlock.addClass('viewed');
                }
            });

        }

    }


    var clipBlocks = new ClipBlocksAnimation({
        selector: '.clip-block'
    });


    function setClipInitSize() {

        var clipOffset = 100;

        $('.clip-block:not(".viewed")').each(function () {

            var $this = $(this);

            if ($this.hasClass('viewed')) return;

            var thisWidth = $this.outerWidth();
            var thisHeight = $this.outerHeight();

            $this.attr('data-width', thisWidth);
            $this.attr('data-height', thisHeight);

            if ($this.hasClass('clip-left')) {
                TweenLite.set($this, {clip: "rect(0px " + (thisWidth - clipOffset) + "px " + thisHeight + "px 0)"});
            }

            else if ($this.hasClass('clip-right')) {
                TweenLite.set($this, {clip: "rect(0px " + thisWidth + "px " + thisHeight + "px " + clipOffset + "px)"});
            }

        });
    }


    function isOnScreenSectionInit() {

        var isOnScreenSections = $('.isOnScreenSection, .isOnScreenItem');

        if (isOnScreenSections.length > 0) {
            isOnScreenSection();
        }

        $(document).on('scroll', function (event) {

            if (isOnScreenSections.length > 0) {
                isOnScreenSection();
            }
        });


        function isOnScreenSection() {

            isOnScreenSections.each(function (i) {

                var _ = $(this);

                if (_.isOnScreen(0.6, 0.6)) {

                    _.addClass('isOnScreen');

                    isOnScreenSections.splice(i, 1);
                }

            });
        }
    }


    function updateTravelNav() {

        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var triggerPosition = scrollTop + windowHeight;

        var firstBlock = $('.travel-block:first-child');
        var firstBlockOffset = firstBlock.offset();


        if (triggerPosition > firstBlockOffset.top + firstBlock.height() / 2) {
            $('#travel-nav').addClass('active');
        }

        else {
            $('#travel-nav').removeClass('active');
        }


        $('.travel-block').each(function () {

            var _ = $(this);

            var offset = _.offset();

            var triggerAreaStart = offset.top + _.height() / 2;
            var triggerAreaEnd = offset.top + _.height() + 40;

            if (triggerPosition > triggerAreaStart && triggerPosition < triggerAreaEnd) {
                $('#travel-nav li').removeClass('active');
                $('#travel-nav li').eq(_.index()).addClass('active');
            }

        })
    }


    function mainNavVisibilityToggle() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > 50) {
            $('#main-navbar').addClass('hide');

            if ($('#main-nav-toggle').is('.open')) {
                $('#main-nav-toggle').removeClass('open');
                $('#main-nav').fadeOut(300);
            }
        }

        else {
            $('#main-navbar').removeClass('hide');
        }
    }


    $('#main-nav-toggle').on('click', function () {

        var _toggle = $(this);

        var $body = $('body');

        var _navID = _toggle.data('nav-target');

        var _nav = $(_navID);


        if (_toggle.is('.open')) {
            _toggle.removeClass('open');

            $body.removeClass('nav-open');
            _nav.fadeOut(300);
        }

        else {
            _toggle.addClass('open');
            $body.addClass('nav-open');

            _nav.css("display", "flex")
                .hide()
                .fadeIn(300);
        }
    });


    $(window).on('load', function () {

        setClipInitSize();

        setTimeout(function () {
            clipBlocks.create();
        }, 200)

        hidePreloader();
    });

    $(window).on('load resize', function () {
        setClipContainerHeight();
        setClipParentHeight();

        mainNavVisibilityToggle();
        isOnScreenSectionInit();

        vidRescale();

    });


    $(document).on('scroll', function (event) {


        if ($('body').hasClass('home-page')) {
            updateTravelNav();

            if (isIpad) {
                autoPlayVideoForIpad();
            }
        }

        mainNavVisibilityToggle();
    });


    var ytPlayers = {};

    onYouTubePlayerAPIReady = function () {

        var players = document.querySelectorAll('.yt-video');

        for (var i = 0; i < players.length; i++) {
            var player = new YT.Player(players[i], {
                playerVars: {
                    'autoplay': 0,
                    'rel': 0,
                    'showinfo': 0,
                    'controls': 1

                },
                videoId: players[i].getAttribute("data-yt-id"),
                events: {
                    'onReady': onPlayerReady
                }

            });

            ytPlayers[players[i].getAttribute("id")] = player;
        }
    };

    function onPlayerReady(event) {

        youTubePlayerReady = true;

        if (!isAndroid && !isIpad && !isIphone){
            ytPlayerPlay();
        }

    }

    function ytPlayerPlay() {

        if (youTubePlayerReady && pageLoaded) {
            ytPlayers.topVideo.playVideo();
        }
    }


    $('.parallax-move').parallaxContent();


    $('.travel-block .title').parallaxContent({
        'shift': 10,
        'duration': 2
    });

    $('.travel-block .description').parallaxContent({
        'shift': 6
    });

    $('.section-top .letter-col .parallax-wrap').parallaxContent({
        'shift': 15
    });

    $('.section-type-title .page-name').parallaxContent({
        'shift': 10
    });

    $('.single-page .section-title').parallaxContent({
        'shift': 15
    });

    $('.single-page .section-name').parallaxContent({
        'shift': 10
    });

    $('.single-page .section-description').parallaxContent({
        'shift': 20
    });

    $('.single-page .section-subtitle').parallaxContent({
        'shift': 10
    });

    $('.single-page .section-image').parallaxContent({
        'shift': 10
    });

    $('.single-page .section-image-caption, .single-page .section-counter').parallaxContent({
        'shift': 20
    });

    $('.section-type-features-list-1 .item-description').parallaxContent({
        'shift': 20
    });


})(jQuery);

